import $ from 'jquery';
import _ from 'lodash';

$.fn.Palette = function() {
  var method = {
    //イベント
    addEvent(_this) {
      //パレットの開閉
      //change the hover event to click event
      _this.click(function() {
        // let _left = _this.position().left + $('#master-navi').width() + _this.closest('.rail__side').width();
        let _top = 25;
        _this.find('._palette').css({
          top: `${_top}px`,
          // left: _left + "px",
        });
      });

      //色の選択
      _this.find('.sys_select_color').click(function(e) {
        e.stopPropagation();
        var color = $(this).attr('data-id');
        // 色設定
        method.setColor(_this, color);
        _this.find('._palette').removeClass('__show');
      });
    },

    //色を設定する
    setColor(_this, color) {
      var _class = _this.find('._selected').attr('class');

      _.each(_class.split(' '), function(value) {
        if (value.match(/^__/g)) {
          _this.find('._selected').removeClass(value);
        }
      });
      _class = _this.find('._selected').attr('class');

      _.each(_class.split(' '), function(value) {
        _this.find('._selected').addClass(value);
      });
      _this.find('._selected').addClass(`__${color}`);
    },
  };

  return this.each(function() {
    var _this = $(this);

    method.addEvent(_this);
  });
};



// WEBPACK FOOTER //
// ./src/canvas/common/palette.js